import { controlsOf, mergeMap, simulate } from "../../lib/console";

// Operator-only stand-in for the two USB button boxes: fires the same events the gamepads would.
export const SimConsole = ({ consoleMap }) => {
  const map = mergeMap(consoleMap);
  return (
    <div data-testid="sim-console" className="mt-3 grid gap-2 border-t border-amber-400/20 pt-3">
      <p className="font-mono text-[11px] uppercase tracking-widest text-amber-300/80">Console simulation · buttons, switches, dials · dimmed = not used in the game</p>
      <div className="flex flex-wrap gap-1.5">
        {controlsOf(map, "button").map((c) => (
          <button key={c.id} data-testid={`sim-press-${c.id}`} onClick={() => simulate({ type: "press", id: c.id })} className={`sim-chip ${c.id === "c.b9" ? "border-emerald-400/60 text-emerald-300" : ""} ${c.enabled === false ? "opacity-40" : ""}`}>{c.name}</button>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {controlsOf(map, "toggle").map((c) => (
          <button key={c.id} data-testid={`sim-toggle-${c.id}`} onClick={() => simulate({ type: "toggle", id: c.id })} className={`sim-chip border-cyan-400/40 text-cyan-200 ${c.enabled === false ? "opacity-40" : ""}`}>⇅ {c.name}</button>
        ))}
      </div>
      <div className="flex flex-wrap gap-3">
        {controlsOf(map, "dial").map((c) => (
          <label key={c.id} className={`flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-amber-200/80 ${c.enabled === false ? "opacity-40" : ""}`}>
            {c.name}
            <select data-testid={`sim-dial-${c.id}`} defaultValue="" onChange={(e) => { if (e.target.value) simulate({ type: "dial", id: c.id, value: Number(e.target.value) }); }} className="lab-input w-16 py-1 text-xs">
              <option value="">–</option>
              {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </label>
        ))}
      </div>
    </div>
  );
};
